/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CustomerUserDto } from '../models/PagedResultDto_CustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_AdminDashboard_AdminKeyContactsDto } from '../models/Wealthlane_CustomerService_Dtos_AdminDashboard_AdminKeyContactsDto';
import type { Wealthlane_CustomerService_Dtos_AdminDashboard_ParticipantActivitiesDto } from '../models/Wealthlane_CustomerService_Dtos_AdminDashboard_ParticipantActivitiesDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CreateCustomerUserDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CreateCustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDeactivationDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDeactivationDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserReActivationDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserReActivationDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserStatusDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserStatusDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_GetAllCustomerUserDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_GetAllCustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_GetCustomerUserDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_GetCustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_UpdateCustomerUserDto } from '../models/Wealthlane_CustomerService_Dtos_CustomerUser_UpdateCustomerUserDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerUserService {

    /**
     * @param statuses 
     * @param isEnabled 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserList(
statuses?: Array<number>,
isEnabled?: Array<boolean>,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-list',
            query: {
                'Statuses': statuses,
                'IsEnabled': isEnabled,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerUserId 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserResendEmailToCustomerUser(
customerUserId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/resend-email-to-customer-user/{customerUserId}',
            path: {
                'customerUserId': customerUserId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param roleId 
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_GetCustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserListByRoleId(
roleId: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerUser_GetCustomerUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-list-by-role-id/{roleId}',
            path: {
                'roleId': roleId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserCustomerUser(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerUser_CreateCustomerUserDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/customer-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppCustomerUserCustomerUser(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerUser_UpdateCustomerUserDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/customer-user/customer-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUser(): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerUserId 
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserById(
customerUserId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-by-id/{customerUserId}',
            path: {
                'customerUserId': customerUserId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerUserId 
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserForUpdateById(
customerUserId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-for-update-by-id/{customerUserId}',
            path: {
                'customerUserId': customerUserId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerId 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserSendCustomerForReApprover(
customerId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/send-customer-for-re-approver/{customerId}',
            path: {
                'customerId': customerId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserStatusList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerUserId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserRemarks(
customerUserId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/remarks/{customerUserId}',
            path: {
                'customerUserId': customerUserId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_GetAllCustomerUserDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUsers(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerUser_GetAllCustomerUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-users',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserDeactivateCustomerUser(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDeactivationDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/deactivate-customer-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserReActivateCustomerUser(
requestBody?: Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserReActivationDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/re-activate-customer-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param customerUserId 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserDeactivationRemarks(
customerUserId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/deactivation-remarks/{customerUserId}',
            path: {
                'customerUserId': customerUserId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns number OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserSystemApprovalRequest(
companyId: string,
): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/system-approval-request/{CompanyId}',
            path: {
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns number OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserParticipantApprovalRequest(
companyId: string,
): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/participant-approval-request/{CompanyId}',
            path: {
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns Wealthlane_CustomerService_Dtos_AdminDashboard_ParticipantActivitiesDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserParticipantRegistered(
companyId: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_AdminDashboard_ParticipantActivitiesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/participant-registered/{CompanyId}',
            path: {
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns Wealthlane_CustomerService_Dtos_AdminDashboard_AdminKeyContactsDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserAdminKeyContacts(
companyId: string,
): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_AdminDashboard_AdminKeyContactsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/admin-key-contacts/{CompanyId}',
            path: {
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param userId 
     * @param permissionName 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerUserCheckUserPermission(
userId: string,
permissionName?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-user/check-user-permission/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'permissionName': permissionName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppCustomerUserCustomerUserForSandbox(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/customer-user/customer-user-for-sandbox',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
